
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.192 6.808c5.077 5.076 5.077 13.308 0 18.384-5.076 5.077-13.308 5.077-18.384 0-5.077-5.076-5.077-13.308 0-18.384 5.077-5.077 13.308-5.077 18.384 0zM16 23a9.437 9.437 0 00-6.051 2.187 11.011 11.011 0 0012.103.001A9.435 9.435 0 0016 23zM8.222 8.222c-4.296 4.296-4.296 11.26 0 15.556l.14.137A11.441 11.441 0 0116 21c2.86 0 5.554 1.056 7.638 2.913l.14-.135c4.207-4.206 4.294-10.971.263-15.284l-.263-.272-.272-.263c-4.313-4.031-11.078-3.943-15.284.263zm11.137 2.17a4.75 4.75 0 11-6.718 6.718 4.75 4.75 0 016.718-6.719zm-5.304 1.414a2.75 2.75 0 104.043.166l-.153-.166-.166-.153a2.75 2.75 0 00-3.724.153z","fill":"#011936","fill-rule":"evenodd"}})])
          )
        }
      }
    